import { css } from "@emotion/css";
import {
  Heading,
  CalendarGrid,
  CalendarGridHeader,
  CalendarHeaderCell,
  CalendarGridBody,
  CalendarCell,
} from "react-aria-components";

import { GhostIconButton } from "../../../button/GhostIconButton";
import { useGetAllFocusShadows } from "../../../utils";
import { useDatePickerStyles } from "../utils";

export function DatePickerCalendar() {
  const getAllFocusShadows = useGetAllFocusShadows();
  const styles = useDatePickerStyles();
  return (
    <>
      <header className={styles.header}>
        <GhostIconButton icon="arrow_back_ios_new" slot="previous" />
        <Heading className={styles.heading} />
        <GhostIconButton icon="arrow_forward_ios" slot="next" />
      </header>
      <CalendarGrid className={styles.calendarGrid}>
        <CalendarGridHeader>
          {(day) => (
            <CalendarHeaderCell className={styles.headerCell}>
              {day}
            </CalendarHeaderCell>
          )}
        </CalendarGridHeader>
        <CalendarGridBody>
          {(date) => (
            <CalendarCell
              className={css(styles.calendarCell, {
                "&:focus-within": getAllFocusShadows(),
              })}
              date={date}
            />
          )}
        </CalendarGridBody>
      </CalendarGrid>
    </>
  );
}
